import { render, staticRenderFns } from "./Bu.vue?vue&type=template&id=3358e40e&scoped=true"
import script from "./Bu.vue?vue&type=script&lang=js"
export * from "./Bu.vue?vue&type=script&lang=js"
import style0 from "./Bu.vue?vue&type=style&index=0&id=3358e40e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358e40e",
  null
  
)

export default component.exports